import React from "react";

const DatesTabContent = ({ initialData, formatDateForInput }) => {
  const data = initialData || {}; // Ensure data is an object

  return (
    <div className="grid grid-cols-2 gap-6">
      <div className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Дата интервью
          </label>
          <input
            type="date"
            name="date_of_interview"
            defaultValue={formatDateForInput(data.date_of_interview)}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Дата перевода
          </label>
          <input
            type="date"
            name="date_of_translate"
            defaultValue={formatDateForInput(data.date_of_translate)}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          />
        </div>
      </div>

      <div className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Дата оффера
          </label>
          <input
            type="date"
            name="date_of_offer"
            defaultValue={formatDateForInput(data.date_of_offer)}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Дата увольнения
          </label>
          <input
            type="date"
            name="date_of_fired"
            defaultValue={formatDateForInput(data.date_of_fired)}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Рабочий телефон
          </label>
          <input
            type="tel"
            name="working_phone"
            defaultValue={data.working_phone || ""}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          />
        </div>
      </div>
    </div>
  );
};

export default DatesTabContent;
